import { AppIconType, Icons } from '@nxsys/types/icons';
import { Space } from 'antd';

type Props = {
  icon?: React.ReactNode;
  title: string;
  className?: string;
  iconName?: AppIconType;
};

const AppIconCard: React.FC<Props> = ({ icon, title, className, iconName }) => {
  const Icon = iconName ? Icons[iconName] : null;

  return (
    <Space align="center" className={className}>
      <div className="rounded-[6px] p-[8px] border-solid border-[#CDDDD9] border-[1px] bg-[#F9FBFA]">
        {icon || (Icon && <Icon width={20} height={20} color="#04533F" />)}
      </div>
      <div>{title}</div>
    </Space>
  );
};

export default AppIconCard;
